<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="User Group Name"
                invalid-feedback="User group name should be filled"
                required
                v-model="$v.userGroupForm.name.$model"
                :is-valid="!$v.userGroupForm.name.$invalid"
              />
            </CCol>

            <CCol lg="3">
                <div class="status">
                  <label for="status">Status</label>
                  <model-select
                    class="form-control"
                    id="status"
                    :options="statusList"
                    v-model="$v.userGroupForm.status.$model"
                    :isError="$v.userGroupForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                        v-if="$v.userGroupForm.status.$invalid"
                        class="invalid-feedback-custom"
                      >Status should be filled.</div>
                </div>
              </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.userGroupForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.userGroupForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productCategoryForm.description.$model"
                :is-valid="!$v.productCategoryForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.userGroupForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "UserGroup",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "User Group",
      statusList: [
        { value: "1", text: "Aktif" },
        { value: "0", text: "Non Aktif" },
      ],

      fields: [
        { key: "name", label: "Group Konsumen", sorter: true },
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      userGroupForm: tableInterfaces.user_group,
      isLoading: false,
      addButton: false,
      isEdit: false,
      //  options: [
      //   { value: "1", label: "Yes" },
      //   { value: "0", label: "No" },
      // ],

      
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    userGroupForm: {
      name: { required },
      description: {required},
      status: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getUserGroup();
    },
    getUserGroup: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/user_group/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.userGroupForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.user_group) {
        tableInterfaces.user_group[i] = null;
      }
      this.userGroupForm = tableInterfaces.user_group;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/user_group/edit", this.userGroupForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/user_group/add", this.userGroupForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.userGroupForm.description = html
    },
  },
  
  mounted() {
    this.init();
  },
};
</script>
